import { ADMIN, MEMBER } from "./constants";

export function getNow() {
  return new Date().toISOString().split("T")[0];
}

export function getOptions(items, key = "name", includeBlank = false) {
  const options = items.map((item) => ({ name: item[key], value: item.id }));
  if (includeBlank) {
    options.unshift({ name: "---", value: "" });
  }
  return options;
}

export function getJobFields(users) {
  return [
    {
      name: "Name",
      id: "name",
      type: "text",
    },
    {
      name: "Reward",
      id: "rewardAmount",
      type: "number",
    },
    {
      name: "Family",
      id: "family",
      type: "hidden",
    },
    {
      name: "Available to",
      id: "availableTo",
      type: "select",
      multiple: true,
      options: getOptions(users),
    },
  ];
}

export function getResponsibilityFields(users) {
  return [
    {
      name: "Name",
      id: "name",
      type: "text",
    },
    {
      name: "Times per week",
      id: "timesPerWeek",
      type: "number",
    },
    {
      name: "Family",
      id: "family",
      type: "hidden",
    },
    {
      name: "Available to",
      id: "availableTo",
      type: "select",
      multiple: true,
      options: getOptions(users),
    },
  ];
}

export function getSubmissionFields(users, user) {
  let showPerson;
  if (user.profileType === ADMIN) {
    showPerson = true;
  } else {
    showPerson = false;
  }
  return [
    {
      name: "Person",
      id: "user",
      type: showPerson ? "select" : "hidden",
      options: getOptions(users, "name", true),
    },
    {
      name: "Date",
      id: "startDate",
      type: "date",
      required: true,
    },
  ];
}

export function getPerformedJobFields(user, users, jobs) {
  let jobsForUser = jobs;
  if (user.profileType === ADMIN) {
    jobsForUser = jobs;
  } else {
    jobsForUser = jobs.filter((job) => job.availableTo.includes(user.id));
  }

  return [
    {
      name: "Person",
      id: "user",
      type: user.profileType === ADMIN ? "select" : "hidden",
      options: getOptions(users, "name", true),
    },
    {
      name: "Job",
      id: "job",
      type: "select",
      options: getOptions(jobsForUser, "name", true),
    },
    {
      name: "Date performed",
      id: "datePerformed",
      type: "date",
      required: true,
    },
    {
      name: "Submission",
      id: "submission",
      type: "hidden",
    },
  ];
}

export function getPerformedResponsibilityFields(
  user,
  users,
  responsibilities
) {
  let responsibilitiesForUser;
  if (user.profileType === ADMIN) {
    responsibilitiesForUser = responsibilities;
  } else {
    responsibilitiesForUser = responsibilities.filter((responsibility) =>
      responsibility.availableTo.includes(user.id)
    );
  }

  return [
    {
      name: "Person",
      id: "user",
      type: user.profileType === ADMIN ? "select" : "hidden",
      options: getOptions(users, "name", true),
    },
    {
      name: "Responsibility",
      id: "responsibility",
      type: "select",
      options: getOptions(responsibilitiesForUser, "name", true),
    },
    {
      name: "Date performed",
      id: "datePerformed",
      type: "date",
      required: true,
    },
    {
      name: "Submission",
      id: "submission",
      type: "hidden",
    },
  ];
}

export function getInviteFields(type) {
  const baseFields = [
    {
      name: "Email",
      id: "email",
      type: "email",
    },
    {
      name: "Family",
      id: "family",
      type: "hidden",
    },
    {
      type: "select",
      id: "profileType",
      options: [
        {
          name: "Member",
          value: MEMBER,
        },
        {
          name: "Admin",
          value: ADMIN,
        },
      ],
      name: "Type",
    },
  ];
  if (type === MEMBER) {
    return [
      ...baseFields,
      {
        name: "Responsibility reward",
        id: "responsibilityReward",
        type: "number",
      },
    ];
  }
  return baseFields;
}

export function getFamilyFields() {
  return [
    {
      name: "Name",
      id: "name",
      type: "text",
    },
  ];
}

export function getTransactionFields(users) {
  return [
    {
      name: "Person",
      id: "user",
      type: "hidden",
      options: getOptions(users, "name", true),
    },
    {
      name: "Name",
      id: "name",
      type: "text",
    },
    {
      name: "Amount",
      id: "amount",
      type: "number",
    },
  ];
}
